import React from 'react'

import { Join, Space } from '@gousto-internal/citrus-react'

import { AlternativeOptionItem } from '../AlternativeOptionItem'
import { useTrackVariantListDisplay } from './useTracking'

import css from './RecipeAlternativeOptions.css'

export type RecipeAlternativeOptionsProps = {
  recipeId: string
  /**
   * Optional Function to be called upon switching recipes.
   */
  onChangeCheckedRecipe: (_: { previousRecipeId: string; nextRecipeId: string }) => void
  selectVariant: ({
    variantId,
    variantOutOfStock,
  }: {
    variantId: string
    variantOutOfStock: boolean
  }) => void
  alternativeOptions: {
    recipeId: string
    recipeName: string
    isChecked: boolean
    isOutOfStock: boolean
    surcharge: number | null
  }[]
}

export const RecipeAlternativeOptions = ({
  recipeId: currentRecipeId,
  onChangeCheckedRecipe,
  selectVariant,
  alternativeOptions,
}: RecipeAlternativeOptionsProps) => {
  // alternative options include the recipe itself
  const ALTERNATIVE_OPTIONS_STARTING_LENGTH = 1

  const hasAlternativeOptions = alternativeOptions.length > ALTERNATIVE_OPTIONS_STARTING_LENGTH

  useTrackVariantListDisplay({
    hasAlternativeOptions,
    view: 'grid',
  })

  const preventPropagation = (e: React.SyntheticEvent) => e.stopPropagation()

  if (!hasAlternativeOptions) {
    return null
  }

  return (
    <div
      className={css.recipeList}
      role="button"
      tabIndex={-1}
      onClick={preventPropagation}
      onKeyPress={preventPropagation}
    >
      <Join with={<Space size={4} />}>
        <ul className={css.recipeListText}>
          {alternativeOptions.map(
            ({ recipeId, recipeName, isChecked, isOutOfStock, surcharge }) => (
              <AlternativeOptionItem
                key={recipeId}
                recipeId={recipeId}
                recipeName={recipeName}
                onChange={() => {
                  selectVariant({ variantId: recipeId, variantOutOfStock: isOutOfStock })
                  onChangeCheckedRecipe({
                    previousRecipeId: currentRecipeId,
                    nextRecipeId: recipeId,
                  })
                }}
                isChecked={isChecked}
                isOutOfStock={isOutOfStock}
                surcharge={surcharge === undefined ? null : surcharge}
              />
            ),
          )}
        </ul>
      </Join>
    </div>
  )
}
